import type { TypographyProps } from "@mui/material";
import { Stack, Typography } from "@mui/material";
import BadgeDetached from "./BadgeDetached";

interface Props {
  title: string;
  items: string[];
  maxVisibleItems: number;
  expanded: boolean;
  titleTypographyProps?: TypographyProps;
  itemTypographyProps?: TypographyProps;
}

const LimitedListWithBadge = ({
  title,
  items,
  maxVisibleItems,
  expanded,
  titleTypographyProps,
  itemTypographyProps,
}: Props) => {
  return (
    <Stack spacing={0.5} sx={{ alignItems: "flex-start" }}>
      <Stack direction="row" spacing={0.5}>
        <Typography variant="subtitle2" {...titleTypographyProps}>
          {title}
        </Typography>
        <BadgeDetached badgeContent={items.length} color="secondary" />
      </Stack>
      {(expanded ? items : items.slice(0, maxVisibleItems)).map((item) => (
        <Typography key={item} {...itemTypographyProps}>
          {item}
        </Typography>
      ))}
    </Stack>
  );
};

export default LimitedListWithBadge;
